import { Box } from '@mui/material';
import TextField from '@mui/material/TextField';
import FormLabel from '@mui/material/FormLabel';

const FromikTextField = ({ formik, name, label, ...props }) => {
  return (
    <Box>
      <FormLabel sx={{fontStyle:"inherit", color:"#000000" }}>
        {label}
      </FormLabel>
      <TextField
        sx={{
          mt: 1,
          "& .MuiOutlinedInput-root": {
            borderRadius: 3,
            bgcolor: "white"
          }
        }}
        {...props}
        fullWidth
  
        error={formik.touched[name] && Boolean(formik.errors[name])}
        {...formik.getFieldProps(name)} 
        helperText={formik.touched[name] && formik.errors[name]}
        autoComplete='off'
      />
    </Box>
  );
};

export default FromikTextField;